import axios from "axios";


/**
 *
 * @status no delete
 * @class ContractService
 */
class ContractService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  /**
   * @author Leonel Contreras
   * @description Get the count transactions of the contract of a cliedt of the user
   * @date 25-11-2020
   * @param {String} token
   * @returns {Object}
   * @memberof ContractService
   */
  async getContractsTotalTransactions(token) {
    let response = await axios.get(
      `${this.apiUrl}/contract-transactions-by-clientId`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description Get all contracts by clientId from A3Cloud
   * @date 29-09-2020
   * @param {String} token
   * @returns {Object}
   * @memberof ContractService
   */
  async getContractsByClientId(token) {
    let response = await axios.get(`${this.apiUrl}/contracts-by-clientId`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  }

  /**
   * @author Martín Sánchez
   * @description Get all contracts by clientId from A3Cloud
   * @date 29-09-2020
   * @param {String} token
   * @returns {Object}
   * @memberof ContractService
   */
  async getContractsSignatures(email, token) {
    let resp = await axios
      .get(`${this.apiUrl}/contract-sign-request?email=${email}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return { response: "error,", data: error };
      });
    return resp;
  }

  /**
   * @author Leonel Contreras
   * @description Create a new contract
   * @date 24-08-2020
   * @param {String} token
   * @param {Object} data
   * @returns {Object}
   * @memberof ContractService
   */
  async createContractRenewal(data, token) {
    let response = await axios.post(
      `${this.apiUrl}/contract-plan-renewal`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  }

  /**
   * @author Adrian Montemayor
   * @description charge openpay, onboarding only
   * @date 24-08-2020
   * @param {String} token
   * @param {Object} data
   * @returns {Object}
   * @memberof ContractService
   */
  async createChargeOpenpay(data, token) {
    let response = await axios.post(`${this.apiUrl}/charge-openpay`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  }
  /**
   * @author Adrian Montemayor
   * @description Verify a new contract
   * @date 24-08-2020
   * @param {String} token
   * @param {Object} data
   * @returns {Object}
   * @memberof ContractService
   */
  async contractVerify(data, token) {
    let response = await axios.post(
      `${this.apiUrl}/contract-plan-verification`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  }

  /**
   * @author Leonel Contreras
   * @description Validate if the user can create a token
   * @status no delete
   * @param {String} token
   * @returns {Object}
   */
  async validateContractUser(token) {
    let response = await axios.get(`${this.apiUrl}/contract-user-passthrough`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  }

  /**
   * @author Juan Manuel Lamperti
   * @description Get questionnaries for user
   * @param {String} token
   * @returns {Array}
   */
  async getQuestionnairesByUserId(token, userId) {
    let response = await axios.get(
      `${this.apiUrl}/questionnaires?clientId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  }
}

export { ContractService as default };
